const defaultIdQueryFilterKey = "selected_item_id";
export {
  defaultIdQueryFilterKey
};
//# sourceMappingURL=types.js.map
